import { useCallback, useEffect } from 'react'
import type { NodeEntry } from 'slate'
import { Range, Editor, Transforms } from 'slate'

import { SlateInternal } from './RichTextConstants'
import type { CustomEditor } from './RichTextTypes'

export const useSelectionDecorate = (editor: CustomEditor, active: boolean) => {
  useEffect(() => {
    if (active && !editor.selection) {
      Transforms.select(editor, Editor.start(editor, []))
    }
  }, [active, editor])

  return useCallback(
    ([_node, path]: NodeEntry): Range[] => {
      if (active && editor.selection && !Range.isCollapsed(editor.selection)) {
        const intersection = Range.intersection(editor.selection, Editor.range(editor, path))

        if (intersection == null) {
          return []
        }

        const range = {
          [SlateInternal.pseudoSelection]: true,
          ...intersection,
        }

        return [range]
      }
      return []
    },
    [active, editor],
  )
}
